import { useTranslation } from "react-i18next";
/**
 * 
 * @param {object} item - device from Securonix violations 
 */
export default function RowViolation({ item }) {
    const { t } = useTranslation();
    return (
        <> 
            <h3 className="table-accordion_title">{t("Informations détaillées de la violation")}</h3>
            <div className="webex-resume">
                <div className="webex-resume-item">
                    {item.filepath ? (
                        <p className="webex-resume-text">{t("Chemin du fichier")} : {item.filepath}</p>
                    ) : (item.oldfilepath ? (
                        <p className="webex-resume-text">{t("Ancien chemin du fichier")} : {item.oldfilepath}</p>
                    ) : (item.policyname ? (
                        <p className="webex-resume-text">{t("Description")} : {item.policyname}</p>
                    ) : (item.requesturl && (
                        <p className="webex-resume-text">{t("URL de la requête")} : {item.requesturl}</p>
                    ))))}
                </div>
            </div>
        </>
    );
}